<template>
    <table class="table table-bordered">
        <thead>
        <tr>
            <th>PZN</th>
            <th>Datum</th>
            <th>Uhrzeit</th>
            <th>Menge</th>
            <th>Kalkulierter VK</th>
            <th>Netto EK</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in config">
            <td>
                <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <input type="text" class="form-control" v-model="row.pzn" placeholder="123456">
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
            <td>
                <ValidationProvider :rules="{ required: true, regex: /^(\d{2}).(\d{2}).(\d{4})$/ }" v-slot="{ errors }">
                    <input type="text" class="form-control" v-model="row.datum" placeholder="TT.MM.JJJJ">
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
            <td>
                <ValidationProvider :rules="{ required: true, regex: /^(\d{2}):(\d{2})$/ }" v-slot="{ errors }">
                    <input type="text" class="form-control" v-model="row.uhrzeit" placeholder="hh:mm">
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
            <td>
                <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <input type="text" class="form-control" v-model="row.menge" placeholder="1">
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
            <td>
                <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input type="text" class="form-control" placeholder="00,00" v-model="row.kalkulierterVk">
                    </div>
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
            <td>
                <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input type="text" class="form-control" placeholder="00,00" v-model="row.nettoEk">
                    </div>
                    <div class="text-danger">{{ errors[0] }}</div>
                </ValidationProvider>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>

export default {
    props: {
        dto: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {}
}
</script>
